export const title = "ONBOARDING";
export const desc = (
  <>
    HR team created for all Brightgovers series of new onboarding videos. They
    not only fun to watch and loaded with motivation but also got bright amount
    of useful information combined with tips and trick how to navigate out
    portal. Buckle up and let's go.
  </>
);
